import React from "react";
import { theme, Tooltip, Modal } from 'antd';
import {
  PlusCircleFilled,
  EditOutlined,
} from '@ant-design/icons';
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { URL_CHEMICAL } from "../../constants/urls";
import { dateTimeToHumanString } from "../../frameworks/Util";
import ErrorMessages from "../../common/ErrorMessages";
import { DELETE } from "../../frameworks/HttpClient";
import AddPureChemicalModal from "./AddPureChemicalModal";
import CustomDeleteConfirmButton from "../../common/CustomDeleteConfirmButton";

export default function PureChemicalConfigList(props) {
  const [ errorMessages, setErrorMessages ] = React.useState(false);
  const [ chemicalTarget, setChemicalTarget] = React.useState(null);
  const tableRef = React.useRef(null);
  const {
    token: { colorSuccess },
  } = theme.useToken();

  const { token : { colorWarning }} = theme.useToken();

  const columns = [
    {
      title: 'Action',
      dataIndex: '',
      width : 150,
      key: 'action',
      render: (_, original) => {
        return (
          <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            {!original.is_closed &&               
              <CustomDeleteConfirmButton
                tooltips={"ลบชื่อสารเคมี"}
                title={`ลบชื่อสารเคมี - ${original.name}`}
                content={"คุณต้องการลบชื่อสารเคมีใช่หรือไม่"}
                onOk={ async() => {
                  await handleDeleteChemical(original.id)
                  refreshData();
                }}
                onConfirm={() => refreshData()}
            />}
            {!original.is_closed && <Tooltip triger='hover' title="แก้ไข">
              <ColorButton 
                type='primary'
                override={colorWarning}
                icon={<EditOutlined />}
                style={{ margin : 5}}
                onClick={()=> setChemicalTarget(original)} 
              />
            </Tooltip>}
          </div>
      )}
    },
    {
      title: 'ชื่อเคมีภัณฑ์',
      dataIndex: 'name',
      key: 'name',
      searcher: true,
    },
    {
      title: 'วันที่สร้าง',
      dataIndex: 'created',
      key: 'created',
      render : (value) => dateTimeToHumanString(value)
    },
    {
      title: 'วันที่แก้ไขล่าสุด',
      dataIndex: 'updated',
      key: 'updated',
      render : (value) => dateTimeToHumanString(value)
    },
  ]

  const handleDeleteChemical = async(id) => {
    setErrorMessages(null)
    try {
      await DELETE(`${URL_CHEMICAL.PURE_CHEMICAL}${id}/`)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  return(
    <div>
      <ErrorMessages message={errorMessages}></ErrorMessages>
      <ColorButton
        type={'primary'}
        override={colorSuccess}
        style={{ float : 'right', marginBottom : 10}}
        icon={<PlusCircleFilled />} 
        onClick={() => setChemicalTarget('add')}>
          {"เพิ่มชื่อเคมีภัณฑ์"}
      </ColorButton>

      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_CHEMICAL.PURE_CHEMICAL}
      />

      <AddPureChemicalModal
        open={chemicalTarget ? true : false}
        onClose={() => setChemicalTarget(null)}
        onUpdate={() => {
          setChemicalTarget(null)
          refreshData();
        }}
        target={chemicalTarget}
      />
    </div>
  )
}